export default "__VITE_ASSET__CZ7QzErM__"